import type { SceneMedia } from './scenes/scene-markup';

export const MEDIA_COUNT = 4;

const SAMPLE_BASE = '/onboarding-scenes/assets/illustrations';

// Shown when the Vault has no pictures at all: an illustrated example per
// slot, two of them dressed as videos.
const SAMPLES: SceneMedia[] = [
  { title: 'Life Story Summary', kind: 'photo' },
  { title: 'Growing Up & School', kind: 'video' },
  { title: 'Advice & Wisdom', kind: 'video' },
  { title: 'Custom prompts', kind: 'photo' },
].map((sample, index) => ({
  ...sample,
  id: `sample-${index + 1}`,
  kind: sample.kind as SceneMedia['kind'],
  image: `${SAMPLE_BASE}/sample-${index + 1}.webp`,
  duration: '',
  sample: true,
}));

// With one to three pictures the rest of the slots stay blank cards, mixed
// in between rather than all at the end.
const SLOTS_BY_COUNT: Record<number, number[]> = {
  1: [1],
  2: [0, 2],
  3: [0, 1, 3],
};

export function arrangeMedia(media: SceneMedia[]): (SceneMedia | null)[] {
  if (!media.length) return SAMPLES;
  const slots = SLOTS_BY_COUNT[media.length] ?? [0, 1, 2, 3];
  const arranged = Array<SceneMedia | null>(MEDIA_COUNT).fill(null);
  slots.forEach((slot, index) => {
    arranged[slot] = media[index];
  });
  return arranged;
}
